import { useNavigate } from 'react-router-dom';
import { Sun, Moon, LogOut, ChevronDown, CircleUser, KeyRound } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  IconButton,
} from '@vnetwork/ui/primitives';
import { useTheme } from '@vnetwork/ui/provider';
import { useAuth } from '@/auth/AuthProvider';
import { brand } from '@/config/brand';

export function UserMenu() {
  const navigate = useNavigate();
  const [theme, setTheme] = useTheme();
  const { user, logout } = useAuth();

  const initial = (user?.name ?? user?.email ?? '?').charAt(0).toUpperCase();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <IconButton
        aria-label="Toggle theme"
        variant="ghost"
        onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
      >
        {theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}
      </IconButton>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              background: 'transparent',
              border: 0,
              cursor: 'pointer',
              color: 'var(--vn-fg-default)',
              padding: '4px 8px',
              borderRadius: 'var(--vn-radius-md, 8px)',
            }}
          >
            <span
              aria-hidden
              style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                display: 'grid',
                placeItems: 'center',
                background: 'var(--vn-bg-active)',
                fontSize: 13,
                fontWeight: 600,
              }}
            >
              {initial}
            </span>
            <ChevronDown size={14} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>{user?.email ?? 'Account'}</DropdownMenuLabel>
          <DropdownMenuItem onSelect={() => navigate('/account')}>
            <CircleUser size={15} style={{ marginRight: 8 }} />
            Account
          </DropdownMenuItem>
          {brand.features.apiKeys && (
            <DropdownMenuItem onSelect={() => navigate('/account/api-keys')}>
              <KeyRound size={15} style={{ marginRight: 8 }} />
              API keys
            </DropdownMenuItem>
          )}
          <DropdownMenuSeparator />
          <DropdownMenuItem onSelect={() => logout()}>
            <LogOut size={15} style={{ marginRight: 8 }} />
            Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
